"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaApiErrorCode = exports.handleAxiosError = exports.SkubanaInvalidTokenError = exports.SkubanaAuthMissingError = exports.SkubanaApiError = void 0;
class SkubanaApiError extends Error {
    errors;
    cause;
    constructor(errors, cause) {
        super(getErrorSummary(cause));
        this.errors = errors;
        this.cause = cause;
    }
    get statusCode() {
        return this.cause.response.status;
    }
}
exports.SkubanaApiError = SkubanaApiError;
class SkubanaAuthMissingError extends Error {
    cause;
    constructor(cause) {
        super(getErrorSummary(cause, 'credentials missing'));
        this.cause = cause;
    }
}
exports.SkubanaAuthMissingError = SkubanaAuthMissingError;
class SkubanaInvalidTokenError extends Error {
    cause;
    constructor(cause) {
        super(getErrorSummary(cause, 'invalid token'));
        this.cause = cause;
    }
}
exports.SkubanaInvalidTokenError = SkubanaInvalidTokenError;
function getErrorSummary(error, message) {
    const c = error.config;
    const path = (c.baseURL || '').replace(/\/+$/, '') + (c.url || '').replace(/^\/+/, '');
    return `${(c.method || "?")} ${path}: ${message || error.message}`;
}
/**
 * Used internally
 */
function handleAxiosError(exception) {
    exception.toJSON = function () {
        return {
            message: this.message,
            stack: this.stack,
            statusCode: this.response?.status || null,
            code: this.code || null,
        };
    };
    if (!exception.response) {
        throw exception;
    }
    const response = exception.response;
    if (response.status === 403) {
        throw new SkubanaAuthMissingError(exception);
    }
    else if (response.status === 401 && response.data?.error === 'invalid_token') {
        throw new SkubanaInvalidTokenError(exception);
    }
    else if (!isArrayOfStrings(response.data?.error) && typeof response.data?.error !== 'string') {
        throw exception;
    }
    const responseErrors = (typeof response.data.error === 'string')
        ? [response.data.error]
        : response.data.error;
    const knownErrorCodes = Object.values(SkubanaApiErrorCode);
    const errors = responseErrors.map(rawMessage => {
        if (/^(Invalid Parameter: )?limit cannot exceed /.test(rawMessage)) {
            return { code: SkubanaApiErrorCode.LIMIT_EXCEEDED, message: rawMessage };
        }
        const match = rawMessage.match(/^([^:]+):\s*(.*)$/);
        if (!match || !knownErrorCodes.includes(match[1])) {
            return { code: SkubanaApiErrorCode.UNKNOWN, message: rawMessage };
        }
        const [, code, message] = match;
        return { code, message };
    });
    throw new SkubanaApiError(errors, exception);
}
exports.handleAxiosError = handleAxiosError;
function isArrayOfStrings(obj) {
    return Array.isArray(obj) && obj.every(item => typeof item === 'string');
}
var SkubanaApiErrorCode;
(function (SkubanaApiErrorCode) {
    /**
     * INTERNAL: The error code could not be parsed
     */
    SkubanaApiErrorCode["UNKNOWN"] = "UNKNOWN";
    /**
     * INTERNAL: Limit param exceed max allowed value
     */
    SkubanaApiErrorCode["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
    /**
     * POST/v1.1/inventory/add: Product stock quantity cannot exceed 100,000,000
     * POST/v1.1/inventory/adjust: Product stock quantity cannot exceed 100,000,000
     * POST/v1.1/inventory/remove: Product stock quantity cannot exceed 100,000,000
     * POST/v1.2/inventory: Product stock quantity cannot exceed 100,000,000
     * POST/v1/inventory/add: Product stock quantity cannot exceed 100,000,000
     * POST/v1/inventory/adjust: Product stock quantity cannot exceed 100,000,000
     * POST/v1/inventory/remove: Product stock quantity cannot exceed 100,000,000
     * POST/v1/inventory: Product stock quantity cannot exceed 100,000,000
     * PUT/v1.1/inventory: Product stock quantity cannot exceed 100,000,000
     */
    SkubanaApiErrorCode["ERR_INVENTORY_001"] = "ERR-INVENTORY-001";
    /**
     * POST/v1.1/inventory/add: Locked quantity cannot be lesser than 0
     * POST/v1.1/inventory/add: On hand quantity cannot be lesser than 0
     * POST/v1.1/inventory/adjust: Locked quantity cannot be lesser than 0
     * POST/v1.1/inventory/adjust: On hand quantity cannot be lesser than 0
     * POST/v1.1/inventory/remove: Locked quantity cannot be lesser than 0
     * POST/v1.1/inventory/remove: On hand quantity cannot be lesser than 0
     * POST/v1/inventory/add: Locked quantity cannot be lesser than 0
     * POST/v1/inventory/add: On hand quantity cannot be lesser than 0
     * POST/v1/inventory/adjust: Locked quantity cannot be lesser than 0
     * POST/v1/inventory/adjust: On hand quantity cannot be lesser than 0
     * POST/v1/inventory/remove: Locked quantity cannot be lesser than 0
     * POST/v1/inventory/remove: On hand quantity cannot be lesser than 0
     * PUT/v1.1/inventory: Locked quantity cannot be lesser than 0
     * PUT/v1.1/inventory: On hand quantity cannot be lesser than 0
     */
    SkubanaApiErrorCode["ERR050"] = "ERR050";
    /**
     * POST/v1.1/inventory/add: Allocated quantity cannot be lesser than 0
     * POST/v1.1/inventory/adjust: Allocated quantity cannot be lesser than 0
     * POST/v1.1/inventory/remove: Allocated quantity cannot be lesser than 0
     * POST/v1/inventory/add: Allocated quantity cannot be lesser than 0
     * POST/v1/inventory/adjust: Allocated quantity cannot be lesser than 0
     * POST/v1/inventory/remove: Allocated quantity cannot be lesser than 0
     * PUT/v1.1/inventory: Allocated quantity cannot be lesser than 0
     */
    SkubanaApiErrorCode["ERR051"] = "ERR051";
    /**
     * POST/v1.1/inventory/add: Product does not exists
     * POST/v1.1/inventory/adjust: Product does not exists
     * POST/v1.1/inventory/remove: Product does not exists
     * POST/v1/inventory/add: Product does not exists
     * POST/v1/inventory/adjust: Product does not exists
     * POST/v1/inventory/remove: Product does not exists
     * PUT/v1.1/inventory: Product does not exists
     */
    SkubanaApiErrorCode["ERR053"] = "ERR053";
    /**
     * POST/v1.1/inventory/add: Warehouse not found
     * POST/v1.1/inventory/adjust: Warehouse not found
     * POST/v1.1/inventory/remove: Warehouse not found
     * POST/v1/inventory/add: Warehouse not found
     * POST/v1/inventory/adjust: Warehouse not found
     * POST/v1/inventory/remove: Warehouse not found
     * PUT/v1.1/inventory: Warehouse not found
     */
    SkubanaApiErrorCode["ERR055"] = "ERR055";
    /**
     * POST/v1.1/inventory/add: Stock location not found
     * POST/v1.1/inventory/adjust: Stock location not found
     * POST/v1.1/inventory/remove: Stock location not found
     * POST/v1/inventory/add: Stock location not found
     * POST/v1/inventory/adjust: Stock location not found
     * POST/v1/inventory/remove: Stock location not found
     * PUT/v1.1/inventory: Stock location not found
     */
    SkubanaApiErrorCode["ERR056"] = "ERR056";
    /**
     * POST/v1.1/inventory/add: Stock location is mandatory
     * POST/v1.1/inventory/adjust: Stock location is mandatory
     * POST/v1.1/inventory/remove: Stock location is mandatory
     * POST/v1/inventory/add: Stock location is mandatory
     * POST/v1/inventory/adjust: Stock location is mandatory
     * POST/v1/inventory/remove: Stock location is mandatory
     * PUT/v1.1/inventory: Stock location is mandatory
     */
    SkubanaApiErrorCode["ERR057"] = "ERR057";
    /**
     * POST/v1.1/inventory/add: productId or valid master sku is mandatory
     * POST/v1.1/inventory/adjust: productId or valid master sku is mandatory
     * POST/v1.1/inventory/remove: productId or valid master sku is mandatory
     * POST/v1/inventory/add: productId or valid master sku is mandatory
     * POST/v1/inventory/adjust: productId or valid master sku is mandatory
     * POST/v1/inventory/remove: productId or valid master sku is mandatory
     * PUT/v1.1/inventory: productId or valid master sku is mandatory
     */
    SkubanaApiErrorCode["ERR059"] = "ERR059";
    /**
     * POST/v1.1/inventory/add: Draw rank must be greater than 0
     * POST/v1.1/inventory/adjust: Draw rank must be greater than 0
     * POST/v1.1/inventory/remove: Draw rank must be greater than 0
     * POST/v1/inventory/add: Draw rank must be greater than 0
     * POST/v1/inventory/adjust: Draw rank must be greater than 0
     * POST/v1/inventory/remove: Draw rank must be greater than 0
     * PUT/v1.1/inventory: Draw rank must be greater than 0
     */
    SkubanaApiErrorCode["ERR062"] = "ERR062";
    /**
     * POST/v1.1/inventory/add: Cannot add stock on a virtual product
     * POST/v1.1/inventory/adjust: Cannot add stock on a virtual product
     * POST/v1.1/inventory/remove: Cannot add stock on a virtual product
     * POST/v1/inventory/add: Cannot add stock on a virtual product
     * POST/v1/inventory/adjust: Cannot add stock on a virtual product
     * POST/v1/inventory/remove: Cannot add stock on a virtual product
     * PUT/v1.1/inventory: Cannot add stock on a virtual product
     */
    SkubanaApiErrorCode["ERR067"] = "ERR067";
    /**
     * DELETE/v1/orders/{orderId}/labels: Label does not exist
     * DELETE/v1/product/{productId}/labels: Label does not exist
     * POST/v1/orders/{orderId}/labels: Label does not exist
     * POST/v1/product/{productId}/labels: Label does not exist
     * PUT/v1/order: Label does not exist
     */
    SkubanaApiErrorCode["ERR019"] = "ERR019";
    /**
     * DELETE/v1/orders/{orderId}/labels: The label is already assigned to this order
     * POST/v1/orders/{orderId}/labels: The label is already assigned to this order
     */
    SkubanaApiErrorCode["ERR157"] = "ERR157";
    /**
     * DELETE/v1/purchaseorders/removeitems/{purchaseOrderId}: No warehouses for company
     * POST/v1/purchaseorders/authorize: No warehouses for company
     * POST/v1/purchaseorders/confirm: No warehouses for company
     * POST/v1/purchaseorders/reauthorize: No warehouses for company
     * POST/v1/purchaseorders/receive: No warehouses for company
     * POST/v1/purchaseorders/voiditems/{purchaseOrderId}: No warehouses for company
     * PUT/v1/purchaseorder: No warehouses for company
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: No warehouses for company
     */
    SkubanaApiErrorCode["ERR002"] = "ERR002";
    /**
     * POST/v1/purchaseorders/authorize: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/cancel: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/confirm: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/items/cancel/{purchaseOrderId}: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/items/{purchaseOrderId}: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/reauthorize: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/receive: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/restore: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/void: Purchase Order must have eligible items for operation
     * POST/v1/purchaseorders/voiditems/{purchaseOrderId}: Purchase Order must have eligible items for operation
     * PUT/v1/purchaseorder: Purchase Order must have eligible items for operation
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Purchase Order must have eligible items for operation
     */
    SkubanaApiErrorCode["ERR068"] = "ERR068";
    /**
     * DELETE/v1/purchaseorders/removeitems/{purchaseOrderId}: Provided purchaseOrderId is invalid
     * POST/v1.1/purchaseorders/{purchaseOrderId}/vendormessages: Provided purchaseOrderId is invalid
     * POST/v1.1/purchaseorders: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/authorize: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/cancel: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/confirm: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/items/cancel/{purchaseOrderId}: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/items/{purchaseOrderId}: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/reauthorize: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/receive: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/restore: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/void: Provided purchaseOrderId is invalid
     * POST/v1/purchaseorders/voiditems/{purchaseOrderId}: Provided purchaseOrderId is invalid
     * PUT/v1.1/purchaseorders/{purchaseOrderId}/othercosts: Provided purchaseOrderId is invalid
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Provided purchaseOrderId is invalid
     */
    SkubanaApiErrorCode["ERR069"] = "ERR069";
    /**
     * DELETE/v1/purchaseorders/removeitems/{purchaseOrderId}:
     * POST/v1/purchaseorders/authorize:
     * POST/v1/purchaseorders/cancel:
     * POST/v1/purchaseorders/confirm:
     * POST/v1/purchaseorders/items/cancel/{purchaseOrderId}:
     * POST/v1/purchaseorders/items/{purchaseOrderId}:
     * POST/v1/purchaseorders/reauthorize:
     * POST/v1/purchaseorders/receive:
     * POST/v1/purchaseorders/restore:
     * POST/v1/purchaseorders/void:
     * POST/v1/purchaseorders/voiditems/{purchaseOrderId}:
     */
    SkubanaApiErrorCode["ERR075"] = "ERR075";
    /**
     * POST/v1/purchaseorders/reauthorize: Purchase Order attempting to be re-authorized does not have a AWAITING_MODIFICATION_ACCEPTANCE status
     */
    SkubanaApiErrorCode["ERR086"] = "ERR086";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Order not found
     * POST/v1/orders/restore: Order not found
     * PUT/v1.1/shipment/external: Order not found
     * PUT/v1.1/shipment/standard: Order not found
     * PUT/v1/shipments/rmas: Order not found
     */
    SkubanaApiErrorCode["ERR030"] = "ERR030";
    /**
     * POST/v1/orders/restore: Order status must be CANCELLED or ON HOLD.
     */
    SkubanaApiErrorCode["ERR199"] = "ERR199";
    /**
     * POST/v1.1/purchaseorders/{purchaseOrderId}/vendormessages: To vendor message must not be null and must be less than 3000 characters
     */
    SkubanaApiErrorCode["ERR221"] = "ERR221";
    /**
     * DELETE/v1.1/orders/{orderId}/orderitems: Orders in SHIPPED status
     * POST/v1.1/orders/{orderId}/orderitems: Orders in SHIPPED status
     * POST/v1/orders/cancel: Orders in SHIPPED status
     */
    SkubanaApiErrorCode["ERR101"] = "ERR101";
    /**
     * DELETE/v1.1/orders/{orderId}/orderitems: Order does not exist
     * POST/v1.1/orders/{orderId}/orderitems: Order does not exist
     * POST/v1.1/orders: Order does not exist
     * POST/v1/orders: Order does not exist
     * PUT/v1.1/orders/{orderId}/orderitems: Order does not exist
     */
    SkubanaApiErrorCode["ERR154"] = "ERR154";
    /**
     * DELETE/v1.1/orders/{orderId}/orderitems: Editing an order item's quantity, unit price, and discount is unavailable for this order's sales channel
     * POST/v1.1/orders/{orderId}/orderitems: Editing an order item's quantity, unit price, and discount is unavailable for this order's sales channel
     */
    SkubanaApiErrorCode["ERR222"] = "ERR222";
    /**
     * POST/v1/orders/onhold: Orders already in ON_HOLD status
     */
    SkubanaApiErrorCode["ERR108"] = "ERR108";
    /**
     * POST/v1/orders/onhold: Orders in PENDING_FULLFILMENT cannot be changed to ON_HOLD status
     */
    SkubanaApiErrorCode["ERR174"] = "ERR174";
    /**
     * POST/v1/orders/cancel: Orders in CANCELLED status
     */
    SkubanaApiErrorCode["ERR100"] = "ERR100";
    /**
     * POST/v1/orders/cancel: Each order's sales channel must support refund on cancel:
     * POST/v1/orders/cancel: updateSalesChannels must be true if refundOrdersOnChannels is true
     */
    SkubanaApiErrorCode["ERR207"] = "ERR207";
    /**
     * POST/v1/orders/cancel: Orders are being SHIPPED. Updates have been temporarily locked until the batch finishes.
     */
    SkubanaApiErrorCode["ERR228"] = "ERR228";
    /**
     * DELETE/v1/vendors/products/{vendorProductId}/pricingtiers: The pricing tier for the vendor product has a From quantity greater than a To quantity
     * PUT/v1/vendors/products/{vendorProductId}/pricingtiers: The pricing tier for the vendor product has a From quantity greater than a To quantity
     */
    SkubanaApiErrorCode["ERR125"] = "ERR125";
    /**
     * DELETE/v1/vendors/products/{vendorProductId}/pricingtiers: The pricing tiers for the vendor product cannot overlap with each other
     * PUT/v1/vendors/products/{vendorProductId}/pricingtiers: The pricing tiers for the vendor product cannot overlap with each other
     */
    SkubanaApiErrorCode["ERR126"] = "ERR126";
    /**
     * DELETE/v1/vendors/products/{vendorProductId}/pricingtiers: Pricing tier cost must be at least zero
     * PUT/v1/vendors/products/{vendorProductId}/pricingtiers: Pricing tier cost must be at least zero
     */
    SkubanaApiErrorCode["ERR127"] = "ERR127";
    /**
     * DELETE/v1/vendors/products/{vendorProductId}/pricingtiers: The pricingTierId for the vendorProduct is invalid
     * PUT/v1/vendors/products/{vendorProductId}/pricingtiers: The pricingTierId for the vendorProduct is invalid
     */
    SkubanaApiErrorCode["ERR164"] = "ERR164";
    /**
     * PUT/v1.1/thirdpartylogistics: Unable to validate your connection parameters with the provider: .
     */
    SkubanaApiErrorCode["ERR231"] = "ERR231";
    /**
     * PUT/v1.1/thirdpartylogistics: Warehouse Id is not valid. Use warehouse Id from your company that is a 3PL Warehouse.
     */
    SkubanaApiErrorCode["ERR232"] = "ERR232";
    /**
     * POST/v1/purchaseorders/holds: Hold Code for Purchase Order Item must have a valid quantity greater than zero
     * PUT/v1.1/products/bundles: masterSku already exists
     * PUT/v1.1/products/cores: masterSku already exists
     * PUT/v1.1/products/variations: masterSku already exists
     * PUT/v1.1/products/virtuals: masterSku already exists
     * PUT/v1/products/bundles: masterSku already exists
     * PUT/v1/products/cores: masterSku already exists
     * PUT/v1/products/variations/attributes: masterSku already exists
     * PUT/v1/products/variations: masterSku already exists
     * PUT/v1/products/virtuals: masterSku already exists
     * PUT/v1/purchaseorder: Hold Code for Purchase Order Item must have a valid quantity greater than zero
     * PUT/v1/purchaseorders/holds: Hold Code for Purchase Order Item must have a valid quantity greater than zero
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Hold Code for Purchase Order Item must have a valid quantity greater than zero
     */
    SkubanaApiErrorCode["ERR109"] = "ERR109";
    /**
     * POST/v1/purchaseorders/holds: Hold Code for Purchase Order Item must have a valid warehouseId
     * PUT/v1.1/products/bundles: ImageUrl.url is mandatory
     * PUT/v1.1/products/cores: ImageUrl.url is mandatory
     * PUT/v1.1/products/variations: ImageUrl.url is mandatory
     * PUT/v1.1/products/virtuals: ImageUrl.url is mandatory
     * PUT/v1/products/bundles: ImageUrl.url is mandatory
     * PUT/v1/products/cores: ImageUrl.url is mandatory
     * PUT/v1/products/variations/attributes: ImageUrl.url is mandatory
     * PUT/v1/products/variations: ImageUrl.url is mandatory
     * PUT/v1/products/virtuals: ImageUrl.url is mandatory
     * PUT/v1/purchaseorder: Hold Code for Purchase Order Item must have a valid warehouseId
     * PUT/v1/purchaseorders/holds: Hold Code for Purchase Order Item must have a valid warehouseId
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Hold Code for Purchase Order Item must have a valid warehouseId
     */
    SkubanaApiErrorCode["ERR110"] = "ERR110";
    /**
     * GET/v1/purchaseorders/holds: Hold Code for Purchase Order Item must have a valid purchaseOrderItemId
     * PUT/v1.1/products/bundles: Label not found
     * PUT/v1.1/products/cores: Label not found
     * PUT/v1.1/products/variations: Label not found
     * PUT/v1.1/products/virtuals: Label not found
     * PUT/v1/products/bundles: Label not found
     * PUT/v1/products/cores: Label not found
     * PUT/v1/products/variations/attributes: Label not found
     * PUT/v1/products/variations: Label not found
     * PUT/v1/products/virtuals: Label not found
     */
    SkubanaApiErrorCode["ERR111"] = "ERR111";
    /**
     * PUT/v1.1/products/bundles: Label.name is mandatory
     * PUT/v1.1/products/cores: Label.name is mandatory
     * PUT/v1.1/products/variations: Label.name is mandatory
     * PUT/v1.1/products/virtuals: Label.name is mandatory
     * PUT/v1/products/bundles: Label.name is mandatory
     * PUT/v1/products/cores: Label.name is mandatory
     * PUT/v1/products/variations/attributes: Label.name is mandatory
     * PUT/v1/products/variations: Label.name is mandatory
     * PUT/v1/products/virtuals: Label.name is mandatory
     */
    SkubanaApiErrorCode["ERR112"] = "ERR112";
    /**
     * PUT/v1.1/products/bundles: Label.hexColor is mandatory
     * PUT/v1.1/products/cores: Label.hexColor is mandatory
     * PUT/v1.1/products/variations: Label.hexColor is mandatory
     * PUT/v1.1/products/virtuals: Label.hexColor is mandatory
     * PUT/v1/products/bundles: Label.hexColor is mandatory
     * PUT/v1/products/cores: Label.hexColor is mandatory
     * PUT/v1/products/variations/attributes: Label.hexColor is mandatory
     * PUT/v1/products/variations: Label.hexColor is mandatory
     * PUT/v1/products/virtuals: Label.hexColor is mandatory
     * PUT/v1/vendors/vendorproduct: Vendor's defaultPurchaseOrderFormat is invalid
     * PUT/v1/vendors: Vendor's defaultPurchaseOrderFormat is invalid
     */
    SkubanaApiErrorCode["ERR113"] = "ERR113";
    /**
     * PUT/v1.1/products/bundles: Category not found
     * PUT/v1.1/products/cores: Category not found
     * PUT/v1.1/products/variations: Category not found
     * PUT/v1.1/products/virtuals: Category not found
     * PUT/v1/products/bundles: Category not found
     * PUT/v1/products/cores: Category not found
     * PUT/v1/products/variations/attributes: Category not found
     * PUT/v1/products/variations: Category not found
     * PUT/v1/products/virtuals: Category not found
     */
    SkubanaApiErrorCode["ERR114"] = "ERR114";
    /**
     * POST/v1/vendors: Vendor's defaultPaymentTerm is invalid
     * PUT/v1.1/products/bundles: masterSku is duplicated
     * PUT/v1.1/products/cores: masterSku is duplicated
     * PUT/v1.1/products/variations: masterSku is duplicated
     * PUT/v1.1/products/virtuals: masterSku is duplicated
     * PUT/v1/products/bundles: masterSku is duplicated
     * PUT/v1/products/cores: masterSku is duplicated
     * PUT/v1/products/variations/attributes: masterSku is duplicated
     * PUT/v1/products/variations: masterSku is duplicated
     * PUT/v1/products/virtuals: masterSku is duplicated
     * PUT/v1/vendors/vendorproduct: Vendor's defaultPaymentTerm is invalid
     * PUT/v1/vendors: Vendor's defaultPaymentTerm is invalid
     */
    SkubanaApiErrorCode["ERR115"] = "ERR115";
    /**
     * PUT/v1.1/products/bundles: Bundle product must have bundled items
     * PUT/v1.1/products/cores: Bundle product must have bundled items
     * PUT/v1.1/products/variations: Bundle product must have bundled items
     * PUT/v1.1/products/virtuals: Bundle product must have bundled items
     * PUT/v1/products/bundles: Bundle product must have bundled items
     * PUT/v1/products/cores: Bundle product must have bundled items
     * PUT/v1/products/variations/attributes: Bundle product must have bundled items
     * PUT/v1/products/variations: Bundle product must have bundled items
     * PUT/v1/products/virtuals: Bundle product must have bundled items
     */
    SkubanaApiErrorCode["ERR117"] = "ERR117";
    /**
     * PUT/v1.1/products/bundles: Bundled item product not found
     * PUT/v1.1/products/cores: Bundled item product not found
     * PUT/v1.1/products/variations: Bundled item product not found
     * PUT/v1.1/products/virtuals: Bundled item product not found
     * PUT/v1/products/bundles: Bundled item product not found
     * PUT/v1/products/cores: Bundled item product not found
     * PUT/v1/products/variations/attributes: Bundled item product not found
     * PUT/v1/products/variations: Bundled item product not found
     * PUT/v1/products/virtuals: Bundled item product not found
     */
    SkubanaApiErrorCode["ERR118"] = "ERR118";
    /**
     * PUT/v1.1/products/bundles: Virtual product not found
     * PUT/v1.1/products/cores: Virtual product not found
     * PUT/v1.1/products/variations: Virtual product not found
     * PUT/v1.1/products/virtuals: Virtual product not found
     * PUT/v1/products/bundles: Virtual product not found
     * PUT/v1/products/cores: Virtual product not found
     * PUT/v1/products/variations/attributes: Virtual product not found
     * PUT/v1/products/variations: Virtual product not found
     * PUT/v1/products/virtuals: Virtual product not found
     */
    SkubanaApiErrorCode["ERR130"] = "ERR130";
    /**
     * PUT/v1.1/products/bundles: Specified virtual product is not virtual
     * PUT/v1.1/products/cores: Specified virtual product is not virtual
     * PUT/v1.1/products/variations: Specified virtual product is not virtual
     * PUT/v1.1/products/virtuals: Specified virtual product is not virtual
     * PUT/v1/products/bundles: Specified virtual product is not virtual
     * PUT/v1/products/cores: Specified virtual product is not virtual
     * PUT/v1/products/variations/attributes: Specified virtual product is not virtual
     * PUT/v1/products/variations: Specified virtual product is not virtual
     * PUT/v1/products/virtuals: Specified virtual product is not virtual
     */
    SkubanaApiErrorCode["ERR131"] = "ERR131";
    /**
     * PUT/v1.1/products/bundles: Attribute not found
     * PUT/v1.1/products/cores: Attribute not found
     * PUT/v1.1/products/variations: Attribute not found
     * PUT/v1.1/products/virtuals: Attribute not found
     * PUT/v1/products/bundles: Attribute not found
     * PUT/v1/products/cores: Attribute not found
     * PUT/v1/products/variations/attributes: Attribute not found
     * PUT/v1/products/variations: Attribute not found
     * PUT/v1/products/virtuals: Attribute not found
     */
    SkubanaApiErrorCode["ERR138"] = "ERR138";
    /**
     * POST/v1/products: The specified buyer doest not exist
     * PUT/v1.1/products/bundles: The specified buyer doest not exist
     * PUT/v1.1/products/cores: The specified buyer doest not exist
     * PUT/v1.1/products/variations: The specified buyer doest not exist
     * PUT/v1.1/products/virtuals: The specified buyer doest not exist
     * PUT/v1/products/bundles: The specified buyer doest not exist
     * PUT/v1/products/cores: The specified buyer doest not exist
     * PUT/v1/products/variations/attributes: The specified buyer doest not exist
     * PUT/v1/products/variations: The specified buyer doest not exist
     * PUT/v1/products/virtuals: The specified buyer doest not exist
     */
    SkubanaApiErrorCode["ERR166"] = "ERR166";
    /**
     * PUT/v1.1/products/bundles: Bundled item product already exists
     * PUT/v1.1/products/cores: Bundled item product already exists
     * PUT/v1.1/products/variations: Bundled item product already exists
     * PUT/v1.1/products/virtuals: Bundled item product already exists
     * PUT/v1/products/bundles: Bundled item product already exists
     * PUT/v1/products/cores: Bundled item product already exists
     * PUT/v1/products/variations/attributes: Bundled item product already exists
     * PUT/v1/products/variations: Bundled item product already exists
     * PUT/v1/products/virtuals: Bundled item product already exists
     */
    SkubanaApiErrorCode["ERR201"] = "ERR201";
    /**
     * PUT/v1/purchaseorder: Warehouse is mandatory
     */
    SkubanaApiErrorCode["ERR006"] = "ERR006";
    /**
     * PUT/v1/purchaseorder: Warehouse does not exist
     * PUT/v1/shipments/rmas: Warehouse does not exist
     */
    SkubanaApiErrorCode["ERR007"] = "ERR007";
    /**
     * PUT/v1/purchaseorder: Can only create Purchase Order with status of AWAITING_AUTHORIZATION or AWAITING_VENDOR_CONFIRMATION
     */
    SkubanaApiErrorCode["ERR070"] = "ERR070";
    /**
     * PUT/v1/purchaseorder: Creating Purchase Order requires paymentTerm
     */
    SkubanaApiErrorCode["ERR072"] = "ERR072";
    /**
     * PUT/v1/purchaseorder: Creating Purchase Order requires format
     */
    SkubanaApiErrorCode["ERR073"] = "ERR073";
    /**
     * PUT/v1/purchaseorder: Creating Purchase Order requires vendorConfirmByDate
     */
    SkubanaApiErrorCode["ERR074"] = "ERR074";
    /**
     * PUT/v1/purchaseorder: The vendorProductId sent was invalid. Must be a value greater than 0
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: The vendorProductId sent was invalid. Must be a value greater than 0
     */
    SkubanaApiErrorCode["ERR076"] = "ERR076";
    /**
     * PUT/v1/purchaseorder: The Vendor Product was not found with the given vendorProductId
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: The Vendor Product was not found with the given vendorProductId
     */
    SkubanaApiErrorCode["ERR077"] = "ERR077";
    /**
     * POST/v1/purchaseorders/items/{purchaseOrderId}: Cannot provide a negative quantity when editing a purchase order item
     * PUT/v1/purchaseorder: Cannot provide a negative quantity when editing a purchase order item
     */
    SkubanaApiErrorCode["ERR089"] = "ERR089";
    /**
     * PUT/v1/purchaseorder: Cannot provide a negative value or value greater than 100 for 'percentageTax' when adding items to a Purchase Order
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Cannot provide a negative value or value greater than 100 for 'percentageTax' when adding items to a Purchase Order
     */
    SkubanaApiErrorCode["ERR092"] = "ERR092";
    /**
     * PUT/v1/purchaseorder: Must provide a value for uomUnitQuantity when creating Purchase Order item
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Must provide a value for uomUnitQuantity when creating Purchase Order item
     */
    SkubanaApiErrorCode["ERR094"] = "ERR094";
    /**
     * PUT/v1/purchaseorder: Cannot provide a null or negative value for originalUnitCost when creating Purchase Order item
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Cannot provide a null or negative value for originalUnitCost when creating Purchase Order item
     */
    SkubanaApiErrorCode["ERR095"] = "ERR095";
    /**
     * POST/v1/vendors: The vendorId provided is not valid
     * PUT/v1/purchaseorder: The vendorId provided is not valid
     */
    SkubanaApiErrorCode["ERR122"] = "ERR122";
    /**
     * PUT/v1/purchaseorder: The incotermShippingRuleId or incotermShippingRule is not valid
     */
    SkubanaApiErrorCode["ERR153"] = "ERR153";
    /**
     * POST/v1/purchaseorders/items/{purchaseOrderId}: Discount for item cannot exceed 100 if type is PERCENTAGE
     * PUT/v1/purchaseorder: Discount for item cannot exceed 100 if type is PERCENTAGE
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Discount for item cannot exceed 100 if type is PERCENTAGE
     */
    SkubanaApiErrorCode["ERR169"] = "ERR169";
    /**
     * PUT/v1/purchaseorder: Invalid paymentTermId provided for purchase order
     */
    SkubanaApiErrorCode["ERR178"] = "ERR178";
    /**
     * POST/v1.1/orders: Invalid order.shipCountry
     * POST/v1/orders: Invalid order.shipCountry
     * PUT/v1/order: Invalid order.shipCountry
     */
    SkubanaApiErrorCode["ERR023"] = "ERR023";
    /**
     * POST/v1.1/orders: Shipping carrier is mandatory
     * POST/v1/orders: Shipping carrier is mandatory
     */
    SkubanaApiErrorCode["ERR024"] = "ERR024";
    /**
     * POST/v1.1/orders: Shipping provider not found
     * POST/v1/orders: Shipping provider not found
     */
    SkubanaApiErrorCode["ERR025"] = "ERR025";
    /**
     * POST/v1.1/orders: Shipping service not found
     * POST/v1/orders: Shipping service not found
     */
    SkubanaApiErrorCode["ERR026"] = "ERR026";
    /**
     * POST/v1.1/orders: Package type not found
     * POST/v1/orders: Package type not found
     */
    SkubanaApiErrorCode["ERR028"] = "ERR028";
    /**
     * POST/v1.1/orders: OrderIdentifier not set
     * POST/v1/orders: OrderIdentifier not set
     * PUT/v1.1/orders/{orderId}/orderitems: OrderIdentifier not set
     */
    SkubanaApiErrorCode["ERR155"] = "ERR155";
    /**
     * POST/v1.1/orders: salesChannelId is mandatory when orderNumber is set
     * POST/v1/orders: salesChannelId is mandatory when orderNumber is set
     * PUT/v1.1/orders/{orderId}/orderitems: salesChannelId is mandatory when orderNumber is set
     */
    SkubanaApiErrorCode["ERR156"] = "ERR156";
    /**
     * POST/v1.1/orders: Cannot change fulfillmentSource for order
     * POST/v1/orders: Cannot change fulfillmentSource for order
     */
    SkubanaApiErrorCode["ERR165"] = "ERR165";
    /**
     * POST/v1.1/orders: You cannot update the weight of an order directly if it has Additional Packages. You must update the weight directly on the Additional Packages
     * POST/v1/orders: You cannot update the weight of an order directly if it has Additional Packages. You must update the weight directly on the Additional Packages
     */
    SkubanaApiErrorCode["ERR172"] = "ERR172";
    /**
     * POST/v1/listings: Sales channel is mandatory
     * PUT/v1/listings: Sales channel is mandatory
     */
    SkubanaApiErrorCode["ERR003"] = "ERR003";
    /**
     * POST/v1/listings: Sales channel does not exist
     * PUT/v1/listings: Sales channel does not exist
     */
    SkubanaApiErrorCode["ERR004"] = "ERR004";
    /**
     * PUT/v1/listings: Listing Sku already exists in Skubana for this sales channel
     */
    SkubanaApiErrorCode["ERR139"] = "ERR139";
    /**
     * POST/v1/listings: Listing Sku duplicated in provided input
     * PUT/v1/listings: Listing Sku duplicated in provided input
     */
    SkubanaApiErrorCode["ERR140"] = "ERR140";
    /**
     * POST/v1/listings: listing.productId is mandatory
     * PUT/v1/listings: listing.productId is mandatory
     */
    SkubanaApiErrorCode["ERR179"] = "ERR179";
    /**
     * POST/v1/listings: Product not found
     * PUT/v1/listings: Product not found
     */
    SkubanaApiErrorCode["ERR180"] = "ERR180";
    /**
     * DELETE/v1.1/orders/customfielddefinitions: customFieldDefId does not exist
     * DELETE/v1.1/orders/{orderId}/customfieldvalues: customFieldDefId does not exist
     * DELETE/v1.1/products/customfielddefinitions: customFieldDefId does not exist
     * DELETE/v1.1/products/{productId}/customfieldvalues: customFieldDefId does not exist
     * POST/v1/purchaseorders/receive: Operation to receive this Purchase Order is already in progress
     * PUT/v1.1/orders/{orderId}/customfieldvalues: customFieldDefId does not exist
     * PUT/v1.1/products/{productId}/customfieldvalues: customFieldDefId does not exist
     */
    SkubanaApiErrorCode["ERR208"] = "ERR208";
    /**
     * PUT/v1.1/products/{productId}/customfieldvalues: productId does not exist
     */
    SkubanaApiErrorCode["ERR209"] = "ERR209";
    /**
     * PUT/v1.1/orders/{orderId}/customfieldvalues: customFieldDefId is not global and is already tied to an other product
     * PUT/v1.1/products/{productId}/customfieldvalues: customFieldDefId is not global and is already tied to an other product
     */
    SkubanaApiErrorCode["ERR212"] = "ERR212";
    /**
     * PUT/v1.1/orders/{orderId}/customfieldvalues: customFieldId cannot be set multiple times on the same product or order
     * PUT/v1.1/products/{productId}/customfieldvalues: customFieldId cannot be set multiple times on the same product or order
     */
    SkubanaApiErrorCode["ERR213"] = "ERR213";
    /**
     * PUT/v1.1/orders/{orderId}/customfieldvalues: Maximum count of customFieldValue per product exceeded
     * PUT/v1.1/products/{productId}/customfieldvalues: Maximum count of customFieldValue per product exceeded
     */
    SkubanaApiErrorCode["ERR215"] = "ERR215";
    /**
     * PUT/v1/inventoryunpack/submit: Product must be a kit/bundle type
     */
    SkubanaApiErrorCode["ERR_INVENTORY_UNPACK_001"] = "ERR-INVENTORY-UNPACK-001";
    /**
     * PUT/v1/inventoryunpack/submit: The number of component stock locations does not match the number of bundled items of the product
     */
    SkubanaApiErrorCode["ERR_INVENTORY_UNPACK_002"] = "ERR-INVENTORY-UNPACK-002";
    /**
     * PUT/v1/inventoryunpack/submit: Product stock(s) not found
     */
    SkubanaApiErrorCode["ERR_INVENTORY_UNPACK_003"] = "ERR-INVENTORY-UNPACK-003";
    /**
     * PUT/v1/inventoryunpack/submit: Product stock(s) not active
     */
    SkubanaApiErrorCode["ERR_INVENTORY_UNPACK_004"] = "ERR-INVENTORY-UNPACK-004";
    /**
     * PUT/v1/inventoryunpack/submit: Product stock(s) with not enough on hand inventory
     */
    SkubanaApiErrorCode["ERR_INVENTORY_UNPACK_005"] = "ERR-INVENTORY-UNPACK-005";
    /**
     * PUT/v1/inventoryunpack/submit: Unpackable inventory available quantity is not enough
     */
    SkubanaApiErrorCode["ERR_INVENTORY_UNPACK_006"] = "ERR-INVENTORY-UNPACK-006";
    /**
     * POST/v1/vendors: Could not find any Purchase Order Template with the given ID
     * PUT/v1/vendors/vendorproduct: Could not find any Purchase Order Template with the given ID
     * PUT/v1/vendors: Could not find any Purchase Order Template with the given ID
     */
    SkubanaApiErrorCode["ERR170"] = "ERR170";
    /**
     * PUT/v1.1/shipment/standard: No orders specified for shipment
     */
    SkubanaApiErrorCode["ERR029"] = "ERR029";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Order shipMethod missing
     * PUT/v1.1/shipment/standard: Order shipMethod missing
     */
    SkubanaApiErrorCode["ERR032"] = "ERR032";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Order shipMethod shippingProvider missing
     * PUT/v1.1/shipment/standard: Order shipMethod shippingProvider missing
     */
    SkubanaApiErrorCode["ERR033"] = "ERR033";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Order shipMethod shippingService missing
     * PUT/v1.1/shipment/standard: Order shipMethod shippingService missing
     */
    SkubanaApiErrorCode["ERR034"] = "ERR034";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Order shipMethod packageType missing
     * PUT/v1.1/shipment/standard: Order shipMethod packageType missing
     */
    SkubanaApiErrorCode["ERR035"] = "ERR035";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Order batch not found
     * PUT/v1.1/shipment/external: Order batch not found
     * PUT/v1.1/shipment/standard: Order batch not found
     */
    SkubanaApiErrorCode["ERR036"] = "ERR036";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Cannot ship orders that does not have the same fulfillment source
     * PUT/v1.1/shipment/standard: Cannot ship orders that does not have the same fulfillment source
     */
    SkubanaApiErrorCode["ERR040"] = "ERR040";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/shipment: Shipment orderBatch's fulfillmentSource must be the same as the shipment orders
     * PUT/v1.1/shipment/standard: Shipment orderBatch's fulfillmentSource must be the same as the shipment orders
     */
    SkubanaApiErrorCode["ERR041"] = "ERR041";
    /**
     * GET/v1/inventory/stocktransfers: Stock transfer status must be one of AWAITING_SHIPMENT, PENDING_RECEIVING, or PARTIALLY_DELIVERED in order to be modifiable.
     * PUT/v1/inventory/stocktransfers: Stock transfer status must be one of AWAITING_SHIPMENT, PENDING_RECEIVING, or PARTIALLY_DELIVERED in order to be modifiable.
     */
    SkubanaApiErrorCode["ERR184"] = "ERR184";
    /**
     * PUT/v1/inventory/stocktransfers: Server-side error occurred, preventing the successful creation of this stock transfer.
     */
    SkubanaApiErrorCode["ERR186"] = "ERR186";
    /**
     * PUT/v1/inventory/stocktransfers: No stock transfer number specified. When creating stock transfers, an order number must be specified.
     */
    SkubanaApiErrorCode["ERR191"] = "ERR191";
    /**
     * PUT/v1/inventory/stocktransfers: The stock transfer order number specified already exists. Please specify a unique order number.
     */
    SkubanaApiErrorCode["ERR192"] = "ERR192";
    /**
     * POST/v1/shipments/rmas/markshipped: No RMA exists for the given id
     * PUT/v1/shipments/rmas/items: No RMA exists for the given id
     */
    SkubanaApiErrorCode["ERR202"] = "ERR202";
    /**
     * PUT/v1.1/orders/customfielddefinitions: Name must be unique
     * PUT/v1.1/products/customfielddefinitions: Name must be unique
     */
    SkubanaApiErrorCode["ERR210"] = "ERR210";
    /**
     * POST/v1.1/inventory/add: Product stock list is mandatory
     * POST/v1.1/inventory/adjust: Product stock list is mandatory
     * POST/v1.1/inventory/remove: Product stock list is mandatory
     * POST/v1.2/inventory: Product stock list is mandatory
     * POST/v1/inventory/add: Product stock list is mandatory
     * POST/v1/inventory/adjust: Product stock list is mandatory
     * POST/v1/inventory/remove: Product stock list is mandatory
     * POST/v1/inventory: Product stock list is mandatory
     */
    SkubanaApiErrorCode["ERR049"] = "ERR049";
    /**
     * POST/v1.1/inventory/add: Product stock not found
     * POST/v1.1/inventory/adjust: Product stock not found
     * POST/v1.1/inventory/remove: Product stock not found
     * POST/v1.2/inventory: Product stock not found
     * POST/v1/inventory/add: Product stock not found
     * POST/v1/inventory/adjust: Product stock not found
     * POST/v1/inventory/remove: Product stock not found
     * POST/v1/inventory: Product stock not found
     */
    SkubanaApiErrorCode["ERR097"] = "ERR097";
    /**
     * POST/v1.1/inventory/add: productId or masterSku must be specified
     * POST/v1.1/inventory/adjust: productId or masterSku must be specified
     * POST/v1.1/inventory/remove: productId or masterSku must be specified
     * POST/v1.2/inventory: productId or masterSku must be specified
     * POST/v1/inventory/add: productId or masterSku must be specified
     * POST/v1/inventory/adjust: productId or masterSku must be specified
     * POST/v1/inventory/remove: productId or masterSku must be specified
     * POST/v1/inventory: productId or masterSku must be specified
     */
    SkubanaApiErrorCode["ERR098"] = "ERR098";
    /**
     * POST/v1.1/inventory/add: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1.1/inventory/adjust: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1.1/inventory/remove: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1.2/inventory: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory/add: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory/adjust: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory/remove: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory: stockLocationName is mandatory for DIRECT_FULFILLMENT warehouses
     */
    SkubanaApiErrorCode["ERR143"] = "ERR143";
    /**
     * POST/v1.1/inventory/add: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1.1/inventory/adjust: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1.1/inventory/remove: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1.2/inventory: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory/add: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory/adjust: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory/remove: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     * POST/v1/inventory: allocatedQuantity cannot be set for DIRECT_FULFILLMENT warehouses
     */
    SkubanaApiErrorCode["ERR144"] = "ERR144";
    /**
     * PUT/v1/products/variations/attributes/groups: Attribute group already exists
     */
    SkubanaApiErrorCode["ERR132"] = "ERR132";
    /**
     * POST/v1/order/{orderId}/split: The specified orders cannot be split. Some of the orders specified are inbound shipments.
     */
    SkubanaApiErrorCode["ERR_ORDER_SPLIT_001"] = "ERR-ORDER-SPLIT-001";
    /**
     * POST/v1/order/{orderId}/split: The specified orders cannot be split. The order is in awaiting payment status
     */
    SkubanaApiErrorCode["ERR_ORDER_SPLIT_002"] = "ERR-ORDER-SPLIT-002";
    /**
     * POST/v1/order/{orderId}/split: The specified orders cannot be split. Some of the orders are stock transfers
     */
    SkubanaApiErrorCode["ERR_ORDER_SPLIT_003"] = "ERR-ORDER-SPLIT-003";
    /**
     * POST/v1/order/{orderId}/split: The specified orders cannot be split. The sum of the order amounts of the split order do not match the source order.
     */
    SkubanaApiErrorCode["ERR_ORDER_SPLIT_005"] = "ERR-ORDER-SPLIT-005";
    /**
     * POST/v1/order/{orderId}/split: The specified orders cannot be split. The sum of the split order item quantities do not match the source order.
     */
    SkubanaApiErrorCode["ERR_ORDER_SPLIT_006"] = "ERR-ORDER-SPLIT-006";
    /**
     * POST/v1/order/{orderId}/split: The specified orders cannot be split. The order is a dropship order.
     */
    SkubanaApiErrorCode["ERR_ORDER_SPLIT_007"] = "ERR-ORDER-SPLIT-007";
    /**
     * DELETE/v1.1/orders/customfielddefinitions: Cannot delete. customFieldDef has customFiTERailNotificationToChannel is true
     * DELETE/v1.1/orders/{orderId}/customfieldvalues: Cannot delete. customFieldDef has customFiTERailNotificationToChannel is true
     * DELETE/v1.1/products/customfielddefinitions: Cannot delete. customFieldDef has customFiTERailNotificationToChannel is true
     * DELETE/v1.1/products/{productId}/customfieldvalues: Cannot delete. customFieldDef has customFiTERailNotificationToChannel is true
     */
    SkubanaApiErrorCode["ERR211"] = "ERR211";
    /**
     * POST/v1.1/orders/{orderId}/orderitems: Order item quantity must be greater than zero
     * PUT/v1/order: Order item quantity must be greater than zero
     */
    SkubanaApiErrorCode["ERR010"] = "ERR010";
    /**
     * POST/v1.1/orders/{orderId}/orderitems: Order item money fields must have the same currency as the order.
     * PUT/v1/order: Order item money fields must have the same currency as the order.
     */
    SkubanaApiErrorCode["ERR198"] = "ERR198";
    /**
     * POST/v1.1/orders/{orderId}/orderitems: Order item discount is greater than unit price x quantity:
     */
    SkubanaApiErrorCode["ERR205"] = "ERR205";
    /**
     * POST/v1.1/orders/{orderId}/orderitems: Order item not found for this order
     */
    SkubanaApiErrorCode["ERR224"] = "ERR224";
    /**
     * DELETE/v1/purchaseorders/milestones: Unable to find purchase order milestone
     * POST/v1/inventory/stocktransfers/{stockTransferId}/receive: No product stock found with the specified id.
     * POST/v1/purchaseorders/milestones: Unable to find purchase order milestone
     * POST/v1/purchaseorders/{purchaseOrderId}/milestones: Unable to find purchase order milestone
     */
    SkubanaApiErrorCode["ERR194"] = "ERR194";
    /**
     * PUT/v1.1/organizations/permissions: The organization does not contain the user for which it is being submitted: .
     * PUT/v1.1/organizations: The organization does not contain the user for which it is being submitted: .
     */
    SkubanaApiErrorCode["ERR233"] = "ERR233";
    /**
     * PUT/v1.1/organizations/permissions: The organization does not contain the company for which it is being submitted.
     * PUT/v1.1/organizations: The organization does not contain the company for which it is being submitted.
     */
    SkubanaApiErrorCode["ERR234"] = "ERR234";
    /**
     * POST/v1.1/inventory/add: Product not found
     * POST/v1.1/inventory/adjust: Product not found
     * POST/v1.1/inventory/remove: Product not found
     */
    SkubanaApiErrorCode["ERR230"] = "ERR230";
    /**
     * DELETE/v1/products/categories: Category not found
     * POST/v1/products/categories: Category not found
     */
    SkubanaApiErrorCode["ERR168"] = "ERR168";
    /**
     * PUT/v1/products/images: The productId provided is not valid
     */
    SkubanaApiErrorCode["ERR121"] = "ERR121";
    /**
     * PUT/v1/products/images: The product imageUrl provided is invalid
     */
    SkubanaApiErrorCode["ERR135"] = "ERR135";
    /**
     * POST/v1/purchaseorders/void: does not have a status of PENDING
     * POST/v1/purchaseorders/voiditems/{purchaseOrderId}: does not have a status of PENDING
     */
    SkubanaApiErrorCode["ERR081"] = "ERR081";
    /**
     * DELETE/v1/purchaseorders/removeitems/{purchaseOrderId}: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * POST/v1/purchaseorders/cancel: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * POST/v1/purchaseorders/items/cancel/{purchaseOrderId}: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * POST/v1/purchaseorders/items/{purchaseOrderId}: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * POST/v1/purchaseorders/receive: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * POST/v1/purchaseorders/void: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * POST/v1/purchaseorders/voiditems/{purchaseOrderId}: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: You cannot receive/cancel/void a purchase order or receive/edit/remove/add items if it is tied to a dropship order
     */
    SkubanaApiErrorCode["ERR173"] = "ERR173";
    /**
     * PUT/v1/shipments/rmas: No order item exists for the given id
     */
    SkubanaApiErrorCode["ERR_ORDERITEM_001"] = "ERR-ORDERITEM-001";
    /**
     * PUT/v1/shipments/rmas: When generating an RMA without a label, shippingCarrier must be specified and nonzero
     */
    SkubanaApiErrorCode["ERR_RMA_001"] = "ERR-RMA-001";
    /**
     * PUT/v1/shipments/rmas: Encountered an error while processing RMA return: %s
     */
    SkubanaApiErrorCode["ERR203"] = "ERR203";
    /**
     * PUT/v1/shipments/rmas: When generating a label for an RMA, shippingProviderId, shippingServiceId and packageTypeId must be 1 or greater.
     */
    SkubanaApiErrorCode["ERR204"] = "ERR204";
    /**
     * PUT/v1.1/orders/{orderId}/customfieldvalues: orderId does not exist
     */
    SkubanaApiErrorCode["ERR227"] = "ERR227";
    /**
     * POST/v1/purchaseorders/items/{purchaseOrderId}: Cannot provide a null or negative value for billedUnitCost or landedUnitCost when editing a purchase order item
     */
    SkubanaApiErrorCode["ERR090"] = "ERR090";
    /**
     * DELETE/v1/purchaseorders/removeitems/{purchaseOrderId}: The Purchase Order has no items in PENDING status that are eligible for this operation
     * POST/v1/purchaseorders/cancel: The Purchase Order has no items in PENDING status that are eligible for this operation
     * POST/v1/purchaseorders/items/cancel/{purchaseOrderId}: The Purchase Order has no items in PENDING status that are eligible for this operation
     */
    SkubanaApiErrorCode["ERR083"] = "ERR083";
    /**
     * POST/v1/purchaseorders/cancel: Purchase Order items attempting to be canceled does not have a purchase order with PENDING_DELIVERY or PARTIALLY_DELIVERED status or a PO Item does not have a status of PENDING
     * POST/v1/purchaseorders/items/cancel/{purchaseOrderId}: Purchase Order items attempting to be canceled does not have a purchase order with PENDING_DELIVERY or PARTIALLY_DELIVERED status or a PO Item does not have a status of PENDING
     */
    SkubanaApiErrorCode["ERR085"] = "ERR085";
    /**
     * POST/v1/purchaseorders/receive: does not have a status of PENDING
     */
    SkubanaApiErrorCode["ERR082"] = "ERR082";
    /**
     * POST/v1/purchaseorders/receive: Purchase order item must have existing stock locations if warehouse is DIRECT_FULFILLMENT. Please create a stock location first and then receive.
     */
    SkubanaApiErrorCode["ERR119"] = "ERR119";
    /**
     * POST/v1/purchaseorders/receive: Purchase order item's product stock in the warehouse is not receivable
     */
    SkubanaApiErrorCode["ERR120"] = "ERR120";
    /**
     * PUT/v1.1/shipment/external: Order is missing a fulfillment source
     */
    SkubanaApiErrorCode["ERR103"] = "ERR103";
    /**
     * PUT/v1.1/shipment/external: Shipment is missing order information
     */
    SkubanaApiErrorCode["ERR104"] = "ERR104";
    /**
     * PUT/v1.1/shipment/external: orderId and orderNumber are mutually exclusive
     */
    SkubanaApiErrorCode["ERR105"] = "ERR105";
    /**
     * PUT/v1.1/shipment/external: salesChannelId is mandatory when orderNumber is specified
     */
    SkubanaApiErrorCode["ERR106"] = "ERR106";
    /**
     * PUT/v1.1/shipment/external: Order not found
     */
    SkubanaApiErrorCode["ERR107"] = "ERR107";
    /**
     * PUT/v1.1/shipment/external: FBA Inbound Shipment is not in a ship-able state on Seller Central. If you do not want Skubana to update the sales channel for this shipment, please try again with updateChannel equal to false
     */
    SkubanaApiErrorCode["ERR181"] = "ERR181";
    /**
     * PUT/v1.1/shipment/external: Unable to find FBA Inbound Shipment on Amazon
     */
    SkubanaApiErrorCode["ERR182"] = "ERR182";
    /**
     * PUT/v1.1/shipment/external: Error from Amazon while checking on FBA Inbound Shipment status
     */
    SkubanaApiErrorCode["ERR183"] = "ERR183";
    /**
     * DELETE/v1/purchaseorders/milestones: Unable to delete a milestone that is already assigned to a purchase order
     */
    SkubanaApiErrorCode["ERR195"] = "ERR195";
    /**
     * POST/v1/purchaseorders/confirm: You cannot confirm a Purchase Order that does not have a current status of AWAITING_CONFIRMATION
     */
    SkubanaApiErrorCode["ERR080"] = "ERR080";
    /**
     * POST/v1/vendors/products: The vendorSku provided already exists for this vendor
     */
    SkubanaApiErrorCode["ERR123"] = "ERR123";
    /**
     * POST/v1/vendors/products: The vendorProductId is invalid
     */
    SkubanaApiErrorCode["ERR162"] = "ERR162";
    /**
     * POST/v1/purchaseorders/{purchaseOrderId}/milestones: If updating existing assigned milestones, reached is a required field
     */
    SkubanaApiErrorCode["ERR196"] = "ERR196";
    /**
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Purchase Order attempting to have items added does not have a status of AWAITING_AUTHORIZATION, AWAITING_VENDOR_CONFIRMATION, AWAITING_MODIFICATION_ACCEPTANCE, PENDING_DELIVERY, or PARTIALLY_DELIVERED
     */
    SkubanaApiErrorCode["ERR091"] = "ERR091";
    /**
     * PUT/v1/purchaseorders/items/{purchaseOrderId}: Must provide a value for unitOfMeasure when creating Purchase Order item
     */
    SkubanaApiErrorCode["ERR093"] = "ERR093";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/receive: No stock transfer item found with the specified id.
     */
    SkubanaApiErrorCode["ERR193"] = "ERR193";
    /**
     * POST/v1/inventory/stocktransfers/{stockTransferId}/receive: Cannot receive Stock Transfer Order with Status: ${status}
     */
    SkubanaApiErrorCode["ERR226"] = "ERR226";
    /**
     * POST/v1/product/{productId}/labels: The label is already assigned to this product
     */
    SkubanaApiErrorCode["ERR158"] = "ERR158";
    /**
     * POST/v1/vendors: When creating address in USA, a valid State value must be included
     */
    SkubanaApiErrorCode["ERR142"] = "ERR142";
    /**
     * POST/v1/vendors: Province is mandatory for non-US countries
     */
    SkubanaApiErrorCode["ERR175"] = "ERR175";
    /**
     * PUT/v1/order: Order number already exists
     */
    SkubanaApiErrorCode["ERR008"] = "ERR008";
    /**
     * PUT/v1/order: Order items are mandatory
     */
    SkubanaApiErrorCode["ERR009"] = "ERR009";
    /**
     * PUT/v1/order: Order payment type does not exist
     */
    SkubanaApiErrorCode["ERR018"] = "ERR018";
    /**
     * PUT/v1/order: Customs declaration country not found
     */
    SkubanaApiErrorCode["ERR020"] = "ERR020";
    /**
     * PUT/v1/order: Customs declaration country is mandatory
     */
    SkubanaApiErrorCode["ERR021"] = "ERR021";
    /**
     * PUT/v1/order: Order money fields must all have the same currency.
     */
    SkubanaApiErrorCode["ERR197"] = "ERR197";
    /**
     * DELETE/v1/vendors/products/{vendorProductId}/unitsofmeasures: The unitOfMeasureId for the vendorProduct is invalid
     */
    SkubanaApiErrorCode["ERR163"] = "ERR163";
    /**
     * DELETE/v1/purchaseorders/removeitems/{purchaseOrderId}: Purchase Order attempting to have items removed does not have status of AWAITING_AUTHORIZATION, AWAITING_VENDOR_CONFIRMATION, or AWAITING_MODIFICATION_ACCEPTANCE
     */
    SkubanaApiErrorCode["ERR088"] = "ERR088";
    /**
     * POST/v1/purchaseorders/authorize: You cannot authorize a Purchase Order that does not have a current status of AWAITING_AUTHORIZATION
     */
    SkubanaApiErrorCode["ERR079"] = "ERR079";
    /**
     * POST/v1.1/purchaseorders: Custom purchase order number already exists for this vendor:
     */
    SkubanaApiErrorCode["ERR206"] = "ERR206";
    /**
     * POST/v1.1/purchaseorders: Cannot turn on enable auto updates for purchase order because the company has auto updates disabled for all purchase orders
     */
    SkubanaApiErrorCode["ERR219"] = "ERR219";
    /**
     * PUT/v1.1/products/variations: Attribute group not found
     */
    SkubanaApiErrorCode["ERR133"] = "ERR133";
    /**
     * PUT/v1.1/products/variations: Attribute already exists
     */
    SkubanaApiErrorCode["ERR134"] = "ERR134";
    /**
     * PUT/v1/products/categories: Products not found
     */
    SkubanaApiErrorCode["ERR167"] = "ERR167";
    /**
     * POST/v1/purchaseorders/restore: Purchase Order attempting to be restored does not have a CANCELLED status
     */
    SkubanaApiErrorCode["ERR087"] = "ERR087";
})(SkubanaApiErrorCode = exports.SkubanaApiErrorCode || (exports.SkubanaApiErrorCode = {}));
